export const API_HOST = 'https://neu-eats-backend.herokuapp.com';
export const API_URL = `${API_HOST}/api`;